module.exports = __webpack_public_path__ + "img/IMG_2671_L_Foamcore.d6b0bec5.jpg";